var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.withOrText
    ? _c("div", { staticClass: "divider" }, [
        _c("div", { staticClass: "divider-1" }),
        _vm._v(" "),
        _c("div", { staticClass: "or-text" }, [
          _c("span", [_vm._v(" " + _vm._s(_vm.$t("general.or")) + " ")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider-2" }),
      ])
    : _c("div", { staticClass: "divider divider-3" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }